export const termsModal = {
  wrapper: "fixed inset-0 z-70 flex items-center justify-center",
  overlay: "fixed inset-0 bg-black/30 backdrop-blur-sm",
  container: "relative bg-gray-900 w-full max-w-2xl h-[600px] flex flex-col rounded-lg shadow-xl z-80",
  header: {
    wrapper: "flex-none p-4 border-b border-gray-800 flex justify-center items-center",
    title: "text-xl font-semibold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent"
  },
  content: {
    wrapper: "flex-1 overflow-y-auto p-6 space-y-8",
    section: {
      title: "text-lg font-semibold bg-gradient-to-r from-cyan-400/90 to-blue-500/90 bg-clip-text text-transparent mb-4",
      list: "space-y-3 text-gray-300 list-disc pl-4"
    }
  },
  footer: {
    wrapper: "flex-none p-4 border-t border-gray-800 flex justify-center",
    button: {
      base: "px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200 bg-cyan-500 hover:bg-cyan-400 text-white"
    }
  }
} 